import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TableSplit"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.25 2.25H3.75C2.92157 2.25 2.25 2.92157 2.25 3.75V20.25C2.25 21.0784 2.92157 21.75 3.75 21.75H20.25C21.0784 21.75 21.75 21.0784 21.75 20.25V3.75C21.75 2.92157 21.0784 2.25 20.25 2.25ZM20.25 3.75V6.75H3.75V3.75H20.25ZM12.75 8.25H20.25V13.5H12.75V8.25ZM11.25 13.5H3.75V8.25H11.25V13.5ZM3.75 15H11.25V20.25H3.75V15ZM12.75 20.25V15H20.25V20.25H12.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TableSplit.vue"]]);
